// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fbTJ","colBig":"styles_colBig__3csCS","colSmall":"styles_colSmall__3TMpy"};